module.exports = __webpack_public_path__ + "8903ccad59f79f2b46bd9935f244b2c4.png";